module.exports = __webpack_public_path__ + "img/venus.8ab1525e.jpg";